import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { YoutubePlayerComponent } from './youtube-player.component'
import { YoutubePlayerService } from './shared/youtube-player.service'

@NgModule({
  imports: [
    CommonModule
  ],
  exports: [
    YoutubePlayerComponent
  ],
  declarations: [ YoutubePlayerComponent ],
  providers: [ YoutubePlayerService ]
})
export class YoutubePlayerModule { }



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/youtube-player/youtube-player.module.ts